export default "/_next/static/fonts/tt_norms_pro_demibold-a4ce5f5bc9783a5f3c6844f84e95127c.woff";